import { useState } from "react";
import { useSendCalculatorLeadMutation } from "web_myplann/Api/Calculators/useSendCalculatorLeadMutation";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import type { CalculatorLeadRequestDTO } from "web_myplann/Infrastructure/Api/Api";
import { useOnlineStatus } from "web_myplann/Infrastructure/Hooks/useOnlineStatus";

type Options = {
	onSent?: () => void;
};

export const useCalculatorLead = (
	type: CalculatorType,
	{ onSent }: Options = {},
) => {
	const isOnline = useOnlineStatus();
	const [isOfflineAttempt, setIsOfflineAttempt] = useState(false);
	const {
		mutate: sendLead,
		isPending,
		isSuccess,
		isError,
		reset,
	} = useSendCalculatorLeadMutation({ onSuccess: onSent });

	const send = (payload: CalculatorLeadRequestDTO) => {
		if (!isOnline) {
			setIsOfflineAttempt(true);
			return;
		}

		sendLead({ type, payload });
	};

	const closeDialog = () => {
		setIsOfflineAttempt(false);
		reset();
	};

	return {
		send,
		isPending,
		isSent: isSuccess,
		isFailed: isError || isOfflineAttempt,
		closeDialog,
	};
};
